export class BgLink {
    //サイズを整数にする
    constructor() {
        this.bglinks = {};
    }

    init() {
        this.bglinks = document.querySelectorAll('.js-bglink');
        [].forEach.call(this.bglinks, function (elem) {
            elem.addEventListener('click', function () {
                var linkUrl = this.querySelector('a').getAttribute('href');
                if (linkUrl != null) {
                    window.location.href = linkUrl;
                }
            });
        });
    }

}